import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HelpCircle, BookOpen } from "lucide-react";
import { Button } from "./ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "./ui/sheet";
import { SLUG_META } from "../lib/helpData";

// Botón contextual "¿Cómo usar esta pantalla?" para el encabezado de cada módulo.
// Abre un panel lateral con la guía rápida de ESE módulo + enlace a la guía completa.
export function ScreenHelp({ slug, label = "¿Cómo usar esta pantalla?", compact = false }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const meta = SLUG_META[slug];
  const quick = meta?.quick || [];

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={() => setOpen(true)}
        className="rounded-sm text-muted-foreground hover:text-primary gap-1.5"
        data-testid="screen-help-btn"
        title={label}
      >
        <HelpCircle className="h-4 w-4" />
        {!compact && <span className="hidden xl:inline text-xs">{label}</span>}
      </Button>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-full sm:max-w-md overflow-y-auto" data-testid="screen-help-panel">
          <SheetHeader className="text-left">
            <SheetTitle className="font-heading flex items-center gap-2">
              <HelpCircle className="h-5 w-5 text-primary" />
              Guía rápida
            </SheetTitle>
            <SheetDescription>Cómo usar esta pantalla, paso a paso.</SheetDescription>
          </SheetHeader>

          <div className="mt-5 space-y-4">
            {quick.length > 0 ? (
              <ol className="space-y-2.5" data-testid="screen-help-steps">
                {quick.map((s, i) => (
                  <li key={i} className="flex gap-3 text-sm">
                    <span className="shrink-0 h-5 w-5 rounded-full bg-primary/10 text-primary text-[11px] font-bold flex items-center justify-center mt-0.5">{i + 1}</span>
                    <span className="text-muted-foreground leading-relaxed">{s}</span>
                  </li>
                ))}
              </ol>
            ) : (
              <p className="text-sm text-muted-foreground">Abre la guía completa para ver las instrucciones detalladas de este módulo.</p>
            )}

            <Button
              className="w-full rounded-sm font-bold gap-2"
              onClick={() => { setOpen(false); navigate(`/ayuda?m=${slug}`); }}
              data-testid="screen-help-full-guide"
            >
              <BookOpen className="h-4 w-4" />
              Ver guía completa
            </Button>
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}

export default ScreenHelp;
